import React from 'react';
import { useTranslation } from 'react-i18next';
import BaggageIcon from '../Icons/BaggageIcon';
import CloudIcon from '../Icons/CloudIcon';

interface Props {
  toggleErrorModal(): void;
  securityError: boolean;
  milesRange?: any;
}

const ErrorModalBatch: React.FC<Props> = ({ toggleErrorModal, securityError, milesRange }) => {
  const { t } = useTranslation(['includeTeam']);
  return (
    <div className="success-wrapper" data-testid="error-include-modal">
      <div className="icon-wrapper">{!securityError ? <BaggageIcon /> : <CloudIcon />}</div>
      <span className="title-success">
        {!securityError ? t('includeTeam:lets_try_again') : t('includeTeam:out_of_range')}
      </span>

      {!securityError ? (
        <span className="subtitle">{t('includeTeam:error_occurred')}</span>
      ) : (
        <span className="subtitle">
          {t('includeTeam:send_limit1')} {milesRange?.minMiles} {t('includeTeam:send_limit2')} {milesRange?.maxMiles}{' '}
          {t('includeTeam:send_limit3')}
        </span>
      )}

      <button type="button" className="ok-button" onClick={toggleErrorModal}>
        {t('includeTeam:try_again')}
      </button>
    </div>
  );
};

export default ErrorModalBatch;
